import { injectable } from 'inversify';
import { Centrifuge } from 'centrifuge';
import { getRealm } from 'samolet-oauth2';
import { getWebsocketsUrl } from 'api/routes';

export interface IWebSocketService {
  initialize(token?: string, getTokenProvider?: () => Promise<string>): void;
  getClient(): Centrifuge | null;
  getClientId(): string | null;
  getToken(): string | null;
  isConnected(): boolean;
  connect(): Promise<void>;
  disconnect(): void;
}

@injectable()
class WebSocketService implements IWebSocketService {
  private _client: Centrifuge | null = null;

  private _token: string | null = null;

  private _isInitialized = false;

  private _clientId: string | null = null;

  /**
   * Инициализация клиента с токеном
   */
  initialize(token?: string, getTokenProvider?: () => Promise<string>): void {
    // Сохраняем токен для доступа
    this._token = token ?? null;

    if (!this._isInitialized) {
      this._client = new Centrifuge(getWebsocketsUrl(), {
        token,
        getToken: getTokenProvider,
        data: { realm: getRealm() },
      });

      this._isInitialized = true;
    } else if (this._client && token) {
      // Если клиент уже создан, обновляем токен
      this._client.setToken(token);
    }
    this._client?.once('connected', data => {
      this._clientId = data.client;
    });
    this._client?.once('disconnected', () => {
      this._clientId = null;
    });
  }

  /**
   * Получение клиента
   */
  getClient(): Centrifuge | null {
    return this._client;
  }

  getClientId(): string | null {
    return this._clientId;
  }

  /**
   * Получение токена
   */
  getToken(): string | null {
    return this._token;
  }

  /**
   * Проверка подключения
   */
  isConnected(): boolean {
    return this._client?.state === 'connected';
  }

  /**
   * Подключение
   */
  async connect(): Promise<void> {
    if (this._client) {
      await this._client.connect();
    }
  }

  /**
   * Отключение
   */
  disconnect(): void {
    if (this._client) {
      this._client.disconnect();
    }
  }
}

export default WebSocketService;
